import {types} from './types';

const initialState = {
    list: [],
    view: {
        id: 0,
        to_currency: '',
        from_currency: '',
        value: 0
    }
}

export function exchangeRatesReducer(state = initialState, action) {
    switch (action.type) {
        case types.SET_LIST_EXCHANGE_RATES:
            return { ...state, list: action.payload};
        case types.SET_VIEW_EXCHANGE_RATES:
            return { ...state, view: action.payload};
        default:
            return state
    }
}